import React, { forwardRef } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * Flow brand exclusive icon
 */
export const PriceTagFilledIcon: React.FC<SvgIconProps> = forwardRef((props, ref) => {
  return (
    <SvgIcon viewBox="2 2 20 20" ref={ref} {...props}>
      <path d="M11.28 4.24H20.24V13.2L11.7 21.74L2.74 12.78L11.28 4.24ZM14.72 11.56C15.82 11.56 16.68 10.7 16.68 9.6C16.68 8.5 15.82 7.64 14.72 7.64C13.62 7.64 12.76 8.5 12.76 9.6C12.76 10.7 13.62 11.56 14.72 11.56Z" />
    </SvgIcon>
  );
});
